import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/i18n";

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n, t } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  const change = (code) => {
    i18n.changeLanguage(code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-btn"
        aria-label={t("language.switcher")}
        className={`inline-flex items-center gap-2 text-xs tracking-widest uppercase transition-colors outline-none ${
          variant === "dark"
            ? "text-beige-light/80 hover:text-beige-light"
            : "text-slate-500 hover:text-bordeaux"
        }`}
      >
        <Globe size={13} />
        <span>{current.short}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm min-w-[160px]">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            data-testid={`language-option-${lang.code}`}
            onClick={() => change(lang.code)}
            className="cursor-pointer flex items-center justify-between text-sm"
          >
            <span className="flex items-center gap-3">
              <span className="text-[10px] tracking-widest text-slate-500 w-6">{lang.short}</span>
              <span>{lang.label}</span>
            </span>
            {i18n.language === lang.code && <Check size={13} className="text-bordeaux" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
